import 'react-hot-loader'
import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter, Route } from "react-router-dom";
// Redux
import { Provider } from 'react-redux'

import App from './App';
import * as serviceWorker from './ServiceWorker/serviceWorker';

import { ConnectedRouter } from 'connected-react-router'
import configureStore, { history } from './Redux/store';

import {initializeReactGA} from "./googleAnalytics";
import FullStory from 'react-fullstory';

const ORG_ID = 'P3YY2'; // Fill this in here
initializeReactGA()

const store = configureStore()


ReactDOM.render(
  <Provider store={store}>
    <FullStory org={ORG_ID}/>
    <ConnectedRouter history={history}>
      <HashRouter forceRefresh={false} basename={process.env.PUBLIC_URL}>
        <Route component={App} />
      </HashRouter>
    </ConnectedRouter>
  </Provider>
  ,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
serviceWorker.unregister();

